<template>
  <pl-dialog title="New Course" size="choose_options" :disableOutsideClick="true" @close="$emit('close')">
    <div v-if="selected_tab === ''" class="px-6 pb-8">
      <div class="grid grid-cols-1 mb-5">
        <button
          class="flex items-center space-x-4 hover:bg-primary-new_light px-4 hover:border-primary-dark py-4 rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200"
          @click="selected_tab = 'title_section'"
        >
          <img src="/static/logos/new_roundtable_icon.svg" class="rounded-full" width="23px" height="23px" />
          <span class=""> From Scratch </span>
        </button>
      </div>
      <div class="flex flex-col space-y-4">
        <h4 class="text-base font-poppins text-gray-800">Start a course from your LMS</h4>
        <div v-if="loadingProviders" class="grid grid-cols-2 gap-x-2 gap-y-2">
          <div class="flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse">
            <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
          <div class="flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse">
            <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
          <div class="flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse">
            <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
          <div class="flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse">
            <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
          <div class="flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse">
            <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
        </div>
        <div v-else class="grid grid-cols-2 gap-x-2 gap-y-2">
          <button
            class="flex items-center space-x-3 hover:bg-gray-50 px-4 hover:border-primary-dark py-4 rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200"
            @click="selectProvider({ name: 'Google Classroom', icon_url: '/static/google_class_round.png'})"
          >
            <img src="/static/google_class_round.png" class="rounded-full" width="25px" height="25px" />
            <span> Google Classroom </span>
          </button>
          <button
            class="flex items-center  space-x-3 px-4 py-4  rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200"
            v-for="provider in providers"
            :key="provider.name"
            @click="selectProvider(provider)"
            :class="{'opacity-50': !memberships.school_membership, 'hover:bg-gray-50 hover:border-primary-dark': memberships.school_membership}"
          >
            <img :src="`/static/integrations/${provider.name}.png`" class="rounded-full" width="25px" height="25px" />
            <span> {{ provider.name }} </span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="selected_tab === 'title_section'" class="px-6 pb-6">
      <div class="flex flex-col flex-grow h-full space-y-6 mb-5">
        <div class="flex flex-col space-y-2.5">
          <div class="flex flex-col space-y-1">
            <label class="font-poppins text-gray-800">Title <span class="text-red-500">*</span></label>
            <input
              v-model="form_data.title"
              class="bg-gray-100 text-sm text-gray-700 flex-grow outline-none px-4 py-1.5 focus-within:border-primary w-full rounded placeholder-gray-400"
              :placeholder="'Choose a name for your course...'"
              type="text"
            />
          </div>
          <div class="flex flex-col space-y-1">
            <label class="font-poppins text-gray-800">Section</label>
            <input
              v-model="form_data.section"
              class="bg-gray-100 text-sm text-gray-700 flex-grow outline-none px-4 py-1.5 focus-within:border-primary border border-solid w-full rounded placeholder-gray-400"
              placeholder="Add a section to the course..."
              type="text"
            />
          </div>
        </div>
        <div v-if="hasSchool" class="flex items-center text-sm">
          <pl-checkbox v-model="is_school_course" />
          <div class="flex items-center text-sm -ml-1.5 space-x-2">
            <span class="font-poppins text-gray-800">This is a course in my School: </span>
            <span class="text-sm text-gray-600">
              {{ school.name }}
            </span>
          </div>
        </div>
        <div class="w-full">
          <div class="mb-2">
            <h6 class="text-base font-poppins text-gray-800 font-semibold">Invite Teachers</h6>
          </div>
          <div class="w-full mb-3">
            <div class="w-full bg-gray-100 subpixel-antialiased select-none  flex items-center space-x-2 text-xs text-gray-700 flex-grow outline-none px-3 py-2 mr-2 rounded">
              <i class="fa-solid fa-circle-info"></i>
              <p>You can only invite teachers that have already signed up to Parlay *</p>
            </div>
          </div>
          <div class="w-full mb-3">
            <div v-for="co_teacher in co_teachers" :key="co_teacher.id" class="w-full">
              <div class="flex w-full justify-between bg-gray-100 rounded-lg px-4 py-2 mb-2">
                <div class="flex items-center space-x-3">
                  <img :src="co_teacher.avatar_url" class="w-8 h-8 rounded-full" />
                  <div class="flex font-poppins flex-col">
                    <span class="font-semibold text-gray-800 antialiased">{{ co_teacher.name }}</span>
                    <span class="text-xs antialiased text-gray-600 -mt-0.5">{{ co_teacher.email}}</span>
                  </div>
                </div>
                <button
                  @click="selectCoTeacherToRemove(co_teacher)"
                  class="text-red-500"
                >
                  <i class="fa-solid fa-trash-can text-sm"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="w-full flex items-center space-x-2">
            <input
              class="bg-gray-100 focus-within:border-primary text-sm text-gray-500 flex-grow outline-none px-4 py-1.5 rounded placeholder-gray-400"
              placeholder="Enter a Parlay Teacher's Email"
              v-model="co_teacher_email_to_invite"
              @keyup.enter="addCoteacher"
            />
            <button
              class="flex items-center justify-center w-8 h-8 text-white transition-colors duration-150 bg-gray-500 rounded focus:shadow-outline hover:bg-gray-700"
              :class="{ isLoadingTeacher: 'bg-primary' }"
              @click="addCoteacher"
            >
              <div v-if="isLoadingTeacher === true">
                <div class="container">
                  <span class="circle"></span>
                  <span class="circle"></span>
                  <span class="circle"></span>
                  <span class="circle"></span>
                </div>
              </div>
              <div v-else>
                <i class="fa-solid fa-plus text-base" style="margin-left: 1px; margin-top: -1px"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="w-full flex justify-between items-center">
        <button @click="selected_tab = ''; show_instructions = false; courses = []; selectedCoursesToImport = {};" class="px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100">
          Back
        </button>
        <button
          :disabled="form_data.title === '' || creatingCourseLoader"
          @click="createCourse(selected_tab)"
          class="px-4 flex items-center space-x-2 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary"
        >
          <span>{{ buttonMessage }}</span>
          <div v-if="creatingCourseLoader"class="loader"></div>
        </button>
      </div>
    </div>
    <div v-if="selected_tab === 'lms'" class="px-6 pb-4">
      <div v-if="show_instructions">
        <instructions-to-create-course-from-lms
          :provider="selected_provider"
          @close="$emit('close')"
        />
        <div class="w-full flex justify-between items-center mt-4">
          <button @click="selected_tab = ''; show_instructions = false; courses = []; selectedCoursesToImport = {};" class="px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100">
            Back
          </button>
          <button v-if="!show_instructions"
            :disabled="(selected_tab === 'lms' && !selectedCoursesToImport.id) || creatingCourseLoader"
            @click="createCourse(selected_tab)"
            class="px-4 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary"
          >
            {{ buttonMessage }}
          </button>
        </div>
      </div>
      <div v-else>
        <create-courses-from-lms
          :provider="selected_provider"
          :courses="courses"
          @selectedCourses="selectedCourses"
        />
        <div class="w-full flex justify-between items-center mt-4">
          <button @click="selected_tab = ''; show_instructions = false; courses = []; selectedCoursesToImport = {};" class="px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100">
            Back
          </button>
          <button v-if="!show_instructions"
            :disabled="(selected_tab === 'lms' && !selectedCoursesToImport.id) || creatingCourseLoader"
            @click="createCourse(selected_tab)"
            class="px-4 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary"
          >
            {{ buttonMessage }}
          </button>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import adminServices from 'services/admin/adminServices';
  import { EventBus } from 'utils/event-bus';
  import inviteCoTeacher from 'services/courses/inviteCoTeacher';
  import getBillingInformation from 'services/account/getBillingInformation';
  import googleClassroomService from 'services/googleClassroom/googleClassroomServices';
  import googleClassroom from 'utils/googleClassroom';
  import urlConfigs from 'services/apiConfigs';

  import instructionsToCreateCourseFromLms from './instructionsToCreateCourseFromLms.vue';
  import createCoursesFromLms from './createCoursesFromLms.vue';

  export default Vue.extend({
    data() {
      return {
        form_data: {
          title: '',
          section: '',
        },
        error_title: '',
        is_school_course: true,
        allow_coteachers: false,
        co_teacher_email_to_invite: '',
        co_teachers: [],
        selected_tab: '',
        isLoadingTeacher: false,
        loadingProviders: false,
        providers: [],
        memberships: {},
        show_instructions: false,
        selected_provider: '',
        courses: [],
        selectedCoursesToImport: {},
        creatingCourseLoader: false,
        buttonMessage: 'Done'
      };
    },
    components: {
      createCoursesFromLms,
      instructionsToCreateCourseFromLms,
    },
    computed: {
      ...mapGetters(['getProfile']),
      hasSchool() {
        return this.getProfile.school.school_id;
      },
      school() {
        return this.getProfile.school;
      },
      has_school_membership() {
        if (this.memberships && this.memberships.school_membership) {
          return !this.memberships.school_membership.is_cancelled;
        }
        return false;
      },
    },
    methods: {
      createCourse: async function(tab) {
        this.creatingCourseLoader = true;
        this.buttonMessage = 'Creating...';
        if (tab === 'title_section') {
          await this.submitCourse();
        } else {
          this.createCourseFromLMS();
        }
      },
      submitCourse: async function() {
        this.error_title = '';
        
        if (this.form_data.title.length < 4 || this.form_data.title.length > 99) {
          this.error_title = 'Please provide a Title (between 4 and 99 characters long)';
          const toast = {
            type: 'Error',
            message: this.error_title,
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }

        if (this.error_title) return;

        const coursePayload = {
          title: this.form_data.title,
          sections: this.form_data.section ? [this.form_data.section] : [],
          school_course: this.is_school_course,
          banner_url: '/static/banners/Classical.png',
        };

        try {
          const course = await this.$store.dispatch('createCourse', coursePayload);

          if (course) {
            this.co_teachers.forEach((co_teacher) => {
            const payload = { co_teacher_email_to_invite: co_teacher.email };
            inviteCoTeacher(course.id, payload);
          });
          }
        } catch (error) {
          const toast = { type: 'Error', message: 'There was an error during the process of adding new course!', time: 5000 };
          EventBus.$emit('createToast', toast);
          console.error(error);
        }

        const premadeId = localStorage.getItem('premadeId');

        if (premadeId) {
          this.buttonMessage = 'Redirecting...';
          this.$emit('close');
          setTimeout(() => {
            EventBus.$emit('open-new-premade-modal', premadeId);
            const route = {
              name: 'dashboard',
              params: this.$route.params,
              query: { premade_id: premadeId },
            };
            this.$router.push(route);
            localStorage.removeItem('premadeId');
          }, 300);
          
          return;
        }
        this.$emit('courseCreated');
        this.$emit('close');

        this.form_data = { title: '', section: '' };        
      },
      toggleAllowTeachers() {
        this.allow_coteachers = !this.allow_coteachers;
        this.co_teachers = [];
      },
      addCoteacher: async function () {
        if (this.co_teacher_email_to_invite === '') return;

        if (!this.getProfile.is_paid) {
          const text =
            'ability to add a co-teacher for all your Parlay courses.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }

        this.isLoadingTeacher = true;
        if (this.co_teacher_email_to_invite === this.getProfile.email) {
          const toast = {
            type: 'Error',
            message: 'You cannot invite yourself!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.co_teacher_email_to_invite = '';
          this.isLoadingTeacher = false;
          return;
        }
        const checkCoteachers = this.co_teachers.filter(
          (c) => c.email === this.co_teacher_email_to_invite
        );
        if (checkCoteachers.length > 0) {
          const toast = {
            type: 'Warning',
            message: 'You have already added this co-teacher to the list!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.co_teacher_email_to_invite = '';
          this.isLoadingTeacher = false;
          return;
        }
        const payload = {
          email_query: this.co_teacher_email_to_invite.replace(/\s/g, ''),
        };
        try {
          const verify_co_teacher = await adminServices.getCoteacherByEmail(
            payload
          );
          if (verify_co_teacher.status === 200) {
            if (verify_co_teacher.data[0].role === 'student') {
              const toast = {
                type: 'Error',
                message:
                  'The email inserted belongs to a student account! You cannot add this user as co-teacher!',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
              this.isLoadingTeacher = false;
              return;
            }
            this.co_teachers.push(verify_co_teacher.data[0]);
          }
        } catch (error) {
          const toast = {
            type: 'Error',
            message:
              'There is no Parlay Account associated with this email address',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
        this.co_teacher_email_to_invite = '';
        this.isLoadingTeacher = false;
        return;
      },
      selectCoTeacherToRemove(coteacher) {
        const index = this.co_teachers.indexOf(coteacher);
        if (index !== -1) this.co_teachers.splice(index, 1);
      },
      getEdlinkProviders() {
        this.loadingProviders = true;
        this.$store
          .dispatch('getSsoProviders')
          .then((data) => {
            this.providers = data;
            this.loadingProviders = false;
          })
          .catch((err) => {
            console.error(err);
            this.loadingProviders = false;
          });
      },
      getMembership() {
        getBillingInformation().then((res) => {
          const { memberships } = res.data;
          this.memberships = memberships;
        });
      },
      async getCoursesFromGoogleClassroom() {
        const response =
          await googleClassroomService.getCoursesFromGoogleClassroom();
        if (response && response.data) {
          this.courses = response.data.courses;
        }
      },
      async connectToGoogleClassroom() {
        if (!this.getProfile.google_integration.connected) {
          const { code, email } = await googleClassroom.getCode();
          const redirect_uri = `${urlConfigs.uiURL}`;
          const data = await this.$store.dispatch('getClassroomToken', {
            code,
            redirect_uri,
            email,
          });
          if (data) {
            await this.getCoursesFromGoogleClassroom();
          }
        } else {
          await this.getCoursesFromGoogleClassroom();
        }
      },
      async connectToEdlinklms() {
        const { integration_id } = this.selected_provider;
        const courses = await this.$store.dispatch('getSsoCoursesFromLms', {
          integration_id,
        });
        if (courses) {
          this.courses = courses;
        }
      },
      async selectProvider(provider) {
        this.selected_provider = provider;

        if (provider.name === 'Google Classroom') {
          await this.connectToGoogleClassroom();
          this.selected_tab = 'lms';
          this.show_instructions = false;
          return;
        }
        
        if (provider.name !== 'Google Classroom') {
          if (!this.getProfile.is_paid || (this.getProfile.is_paid && !this.has_school_membership)) {
            return;
          }
          if (!provider.school_connected || !provider.connected) {
            return;
          }
          await this.connectToEdlinklms();
          this.selected_tab = 'lms';
          this.show_instructions = false;
        }
      },
      selectedCourses(event) {
        this.selectedCoursesToImport = event;
      },
      async createGoogleClassroomCourse() {
        const array = [];
        const response =
          await googleClassroomService.getStudentsFromGoogleClassroomCourse(
            this.selectedCoursesToImport.id
          );
        const { data } = response;
        if (data && data.students) {
          data.students.forEach((s) => {
            const student = {
              name: s.profile.name.fullName,
              email: s.profile.emailAddress,
              role: 'student',
              google_classroom_user_id: s.userId,
            };
            array.push(student);
          });
        }
        if (
          this.selectedCoursesToImport.name.length < 4 ||
          this.selectedCoursesToImport.name.length > 99
        ) {
          const toast = {
            type: 'Error',
            message:
              'Please provide a class name (between 4 and 99 characters long)',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.creatingCourseLoader = false;
          return;
        }
        const coursePayload = {
          title: this.selectedCoursesToImport.name,
          sections: this.selectedCoursesToImport.section
            ? [this.selectedCoursesToImport.section]
            : [],
          school_course: this.hasSchool ? true : false,
          banner_url: '/static/banners/Classical.png',
        };
        const course = await this.$store
          .dispatch('createCourse', coursePayload)
          .catch((err) => {
            console.error(err);
            const toast = {
              type: 'Error',
              message:
                'There was an error during the process of creating new course!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.creatingCourseLoader = false;
          });
        if (course) {
          await this.$store
            .dispatch('syncGoogleClassroomCourse', {
              course_id: course.id,
              google_classroom_course_id: this.selectedCoursesToImport.id,
              google_classroom_course_name: this.selectedCoursesToImport.name,
              classroom_users: array,
            })
            .catch((err) => {
              console.error(err);
              this.creatingCourseLoader = false;
            });
          this.$router.push({
            name: 'course.index',
            params: { courseID: course.id },
          });
          this.$emit('close');
        }
      },
      async createEdlinkCourse() {
        if (
          this.selectedCoursesToImport.name.length < 4 ||
          this.selectedCoursesToImport.name.length > 99
        ) {
          const toast = {
            type: 'Error',
            message:
              'Please provide a class name (between 4 and 99 characters long)',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.creatingCourseLoader = false;
          return;
        }

        const payload = {
          edlink_courses: [this.selectedCoursesToImport],
          school_id: this.getProfile.school.school_id,
        };
        const course = await this.$store
          .dispatch('createSsoCoursesFromLms', {
            integration_id: this.selected_provider.integration_id,
            payload,
          })
          .catch(() => (this.creatingCourseLoader = false));
        this.creatingCourseLoader = false;
        if (course) {
          this.$router.push({
            name: 'course.index',
            params: { courseID: course[0].id },
          });
          this.$emit('close');
        }
      },
      async createCourseFromLMS() {
        if (this.selected_provider.name === 'Google Classroom') {
          await this.createGoogleClassroomCourse();
        } else {
          await this.createEdlinkCourse();
        }
        this.creatingCourseLoader = false;
      },
    },
    async mounted() {
      await this.getMembership();
      await this.getEdlinkProviders();
    },
  });
</script>
<style scoped>
  .toggle-checkbox:checked {
    @apply right-0 border-primary;
    right: 0;
    border-color: #72ccd7;
  }
  .toggle-checkbox:checked + .toggle-label {
    @apply bg-primary;
    background-color: #72ccd7;
  }
</style>
<style scoped>
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// newCourseModal.vue?dfa444bc